import { useEffect, useRef, useState } from 'react';

export function useInfiniteScroll(onIntersect: () => void, enabled: boolean, rootMargin = '200px') {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const onIntersectRef = useRef(onIntersect);
  onIntersectRef.current = onIntersect;

  useEffect(() => {
    if (!node || !enabled) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) onIntersectRef.current();
      },
      { root: null, rootMargin }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, [node, enabled, rootMargin]);

  return setNode;
}
